import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const WithTooltip = ({
  children,
  show,
  trigger,
  overlay,
  msg,
  placement,
  delay
}) => {
  const defaultOverlay = (
    <Popover id="popover-basic">
      <Popover.Body>{msg}</Popover.Body>
    </Popover>
  );
  return show ? (
    <OverlayTrigger
      key={msg}
      trigger={trigger}
      overlay={overlay || defaultOverlay}
      placement={placement}
      delay={delay}
      transition={false}
    >
      {({ ref, ...triggerHandler }) => (
        <span ref={ref} {...triggerHandler}>
          {children}
        </span>
      )}
    </OverlayTrigger>
  ) : (
    children
  );
};

export default WithTooltip;
